import React from 'react';
import { noop } from 'lodash';

interface FormContext {
  alert: any;
}

export const FormContext = React.createContext<FormContext>({
  alert: {},
});

export interface IAction {
  onEdit: (a) => void;
  onDelete?: (a) => void;
  onCreate?: () => void;
  onCancel: () => void;
}

interface AlertSummaryContext {
  formVisible: boolean;
  actions: IAction;
}

export const FormActionContext = React.createContext<AlertSummaryContext>({
  actions: {
    onEdit: noop,
    onDelete: noop,
    onCreate: noop,
    onCancel: noop,
  },
  formVisible: false,
});
